var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout",attrs:{"id":"auto-dialer-layout"}},[_c('div',{staticClass:"p-4 rounded-lg card content"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center py-2 header"},[_vm._t("header")],2),_c('Stepper',{attrs:{"steps":[
        _vm.$t('auto-dialer.create.steps.0'),
        _vm.$t('auto-dialer.create.steps.1')
      ],"value":_vm.step,"noNavigation":""},scopedSlots:_vm._u([{key:"step-0",fn:function(){return [_vm._t("step-0")]},proxy:true},{key:"step-1",fn:function(){return [_vm._t("step-1")]},proxy:true}],null,true)})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }